import { render, staticRenderFns } from "./EcommerceGoalOverview.vue?vue&type=template&id=2f778438&"
import script from "./EcommerceGoalOverview.vue?vue&type=script&lang=js&"
export * from "./EcommerceGoalOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f778438')) {
      api.createRecord('2f778438', component.options)
    } else {
      api.reload('2f778438', component.options)
    }
    module.hot.accept("./EcommerceGoalOverview.vue?vue&type=template&id=2f778438&", function () {
      api.rerender('2f778438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceGoalOverview.vue"
export default component.exports